export const searchConsultContent = [
   {
      keywords: ["sale", "deal", "sell", "promotion", "advertising", "bonus", "promotional", "promoting", "coupon", "discount", "rewards", "ads", ""],
      related: {
         images: {
            img: "/images/categories/colors.webp",
            img2x: "/images/categories/colors@2x.webp",
            img3x: "/images/categories/colors@3x.webp"
         },
         title: "sale",
         link: '/sale',
      }
   },
   {
      keywords: ["glittery", 'colors', "gelish colors", "gelish", "all"],
      related: {
         images: {
            img: "/images/menu/desktop/gelish/gel_colors.webp",
            img2x: "/images/menu/desktop/gelish/gel_colors@2x.webp",
            img3x: "/images/menu/desktop/gelish/gel_colors@3x.webp"
         },
         title: "gelish colors",
         link: '/colors/gelish',
      }
   },
   {
      keywords: ["glittery", "colors", "morgan taylor colors", "morgan taylor", "taylor", "morgan taylor", "morgan",],
      related: {
         images: {
            img: "/images/menu/desktop/morgan_taylor/mt_colors.webp",
            img2x: "/images/menu/desktop/morgan_taylor/mt_colors@2x.webp",
            img3x: "/images/menu/desktop/morgan_taylor/mt_colors@3x.webp"
         },
         title: "morgan taylor colors",
         link: '/colors/morgan-taylor',
      }
   },
   {
      keywords: ["glittery", "colors", "xpress dip colors", "xpress dip", "taylor", "xpress dip", ""],
      related: {
         images: {
            img: "/images/categories/xpress-dip.webp",
            img2x: "/images/categories/xpress-dip@2x.webp",
            img3x: "/images/categories/xpress-dip@3x.webp"
         },
         title: "Dip powder colors",
         link: '/colors/xpress-dip-n-brush',
      }
   },
   {
      keywords: ["collection", "collections", "season", "station", "resort", "set"],
      related: {
         images: {
            img: "/images/main_collection/spring-2025/21123-GELMT-SP25-Hand-Glam-Group-Gel-Photo-2.webp",
            img2x: "/images/main_collection/spring-2025/21123-GELMT-SP25-Hand-Glam-Group-Gel-Photo-2@2x.webp",
            img3x: "/images/main_collection/spring-2025/21123-GELMT-SP25-Hand-Glam-Group-Gel-Photo-2@3x.webp"
         },
         title: "collections",
         link: '/colors/collections',
      }
   },
   {
      keywords: ["bundles", "color bundles", "gelish bundles", "set"],
      related: {
         images: {
            img: "/images/menu/desktop/sale/gelish.webp",
            img2x: "/images/menu/desktop/sale/gelish@2x.webp",
            img3x: "/images/menu/desktop/sale/gelish@3x.webp"
         },
         title: "color bundles",
         link: '/colors/bundles',
      }
   },
   {
      keywords: ["purple", "violet", "indigo", "vermilion", "lavender", "amethyst", "grape", "lilac", "purply", "purpleness", "deep", "navy", ""],
      related: {
         images: {
            img: "/images/menu/desktop/colors/purple.webp",
            img2x: "/images/menu/desktop/colors/purple@2x.webp",
            img3x: "/images/menu/desktop/colors/purple@3x.webp"
         },
         title: "purple gelish",
         link: '/colors/gelish/purple',
      }
   },
   {
      keywords: ["pink", "rose", "pinkish", "fuchsia", "magenta", "pastel", "flower", "pale", "salmon", "lipstick", "flamingo", "pinkness", "peach", "strawberry", "warn", "rosy", "roses", "cherry"],
      related: {
         images: {
            img: "/images/menu/desktop/colors/pinks.webp",
            img2x: "/images/menu/desktop/colors/pinks@2x.webp",
            img3x: "/images/menu/desktop/colors/pinks@3x.webp"
         },
         title: "pink gelish",
         link: '/colors/gelish/pink',
      }
   },
   {
      keywords: ["red", "strawberry", "cherry", "crimson", "scarlet", "ruby", "maroon", "carmine", "orange", "blood", "burgundy", "reddish", "cerise", "ruddy", "bloody", "inflamed", "fire", "turkey", "dark red"],
      related: {
         images: {
            img: "/images/menu/desktop/colors/reds.webp",
            img2x: "/images/menu/desktop/colors/reds@2x.webp",
            img3x: "/images/menu/desktop/colors/reds@3x.webp"
         },
         title: "red gelish",
         link: '/colors/gelish/red',
      }
   },
   {
      keywords: ["orange", "coral", "peach", "citrus", "sweet", "tangerine", "orangeness", "peachy", "terracota", "orangish"],
      related: {
         images: {
            img: "/images/menu/desktop/colors/corals.webp",
            img2x: "/images/menu/desktop/colors/corals@2x.webp",
            img3x: "/images/menu/desktop/colors/corals@3x.webp"
         },
         title: "orange & coral gelish",
         link: '/colors/gelish/orange-coral',
      }
   },
   {
      keywords: ["green", "blue", "emerald", "olive", "leaf", "jade", "greenish", "mint", "moss", "nature", "forest", "teal", "cyan", "leafy", "vegetable", "verdigris", "spring", "plant", "lime", "sky", "navy", "turquoise", "cobalt", "azure", "indigo", "ultramarine", "prussian", "violet", "cerulean", "lapis", "blueness", "bluish", "sapphire", "steel", "dye"],
      related: {
         images: {
            img: "/images/menu/desktop/colors/blues.webp",
            img2x: "/images/menu/desktop/colors/blues@2x.webp",
            img3x: "/images/menu/desktop/colors/blues@3x.webp"
         },
         title: "Green & blue gelish",
         link: '/colors/gelish/green-blue',
      }
   },
   {
      keywords: ["neutral", "gray", "tan", "brown", "blonde", "bronze", "beige", "white", "pale", "skin", "light", "nude", "bone", "skinned", "creme", "salmon", "peach", "pink"],
      related: {
         images: {
            img: "/images/menu/desktop/colors/neutral.webp",
            img2x: "/images/menu/desktop/colors/neutral@2x.webp",
            img3x: "/images/menu/desktop/colors/neutral@3x.webp"
         },
         title: "neutral gelish",
         link: '/colors/gelish/neutral',
      }
   },
   {
      keywords: ["glitter", "shimmer", "sparkle", "shine", "gleam", "confetti", "glisten", "glam", "glisten", "glint", "glow", "bling", "tinsel", "glamor", "brightness", "flash", "shininess", "twinkle", , "iridescent", "glittering", "stardust", "flakes", "glossy", "metallic", "flecked", "effect", "effects"],
      related: {
         images: {
            img: "/images/menu/desktop/colors/glitter.webp",
            img2x: "/images/menu/desktop/colors/glitter@2x.webp",
            img3x: "/images/menu/desktop/colors/glitter@3x.webp"
         },
         title: "glitter gelish",
         link: '/colors/gelish/glitter',
      }
   },
   {
      keywords: ["metallic", "effect", "effects", "silver", "shiny", "gold", "metal", "bronze", "shimmer", "silvery", "bimetallic", "chromatic", "metallike", "iridescent", "chrome", "tinny", "bitter", "pearl", "reflective", "stainless steel", "gilded", "glossy", "iron"],
      related: {
         images: {
            img: "/images/menu/desktop/colors/metallic.webp",
            img2x: "/images/menu/desktop/colors/metallic@2x.webp",
            img3x: "/images/menu/desktop/colors/metallic@3x.webp"
         },
         title: "metallic gelish",
         link: '/colors/gelish/metallic',
      }
   },
   {
      keywords: ["soft gel", "extensions", "fingernails", "cuticles", "nail", "tips", "hands", "substitute", "gel", "acrylic", "short", "medium", "round", "coffin", "square", "stiletto", "long", "uv", "neutral", "light", "natural",],
      related: {
         images: {
            img: "/images/menu/desktop/softgel/softgel.webp",
            img2x: "/images/menu/desktop/softgel/softgel@2x.webp",
            img3x: "/images/menu/desktop/softgel/softgel@3x.webp"
         },
         title: "soft gel",
         link: '/soft-gel/short-round',
      }
   },
   {
      keywords: ["light", "illumination", "glow", "ultraviolet", "lightness", "luminescence", "floodlight", "lamps", "led", "electric", "electricity", "tools", "led", "gel curing", "curing", "cure", "comfort", "battery", "replacement", "tray", "unplugged", "portable", "rechargeable", "magnetic", "sanitizable", "touch", "high", "performance", "diamond", "reflectors", "chrome", "glazed", "pedicure", "safelight"],
      related: {
         images: {
            img: "/images/menu/desktop/tools/lights.webp",
            img2x: "/images/menu/desktop/tools/lights@2x.webp",
            img3x: "/images/menu/desktop/tools/lights@3x.webp"
         },
         title: "led lamps",
         link: "/nail-lamps-tools/led-lamps",
      }
   },
   {
      keywords: ["soft gel", "extensions", "fingernails", "cuticles", "nail", "tips", "hands", "substitute", "gel", "acrylic", "short", "medium", "round", "uv"],
      related: {
         images: {
            img: "/images/menu/desktop/softgel/short_round.webp",
            img2x: "/images/menu/desktop/softgel/short_round@2x.webp",
            img3x: "/images/menu/desktop/softgel/short_round@3x.webp"
         },
         title: "short round",
         link: '/soft-gel/short-round',
      }
   },
   {
      keywords: ["soft gel", "extensions", "fingernails", "cuticles", "nail", "tips", "hands", "substitute", "gel", "acrylic", "short", "medium", "round", "uv"],
      related: {
         images: {
            img: "/images/menu/desktop/softgel/medium_round.webp",
            img2x: "/images/menu/desktop/softgel/medium_round@2x.webp",
            img3x: "/images/menu/desktop/softgel/medium_round@3x.webp"
         },
         title: "medium round",
         link: '/soft-gel/medium-round',
      }
   },
   {
      keywords: ["soft gel", "extensions", "fingernails", "cuticles", "nail", "tips", "hands", "substitute", "gel", "acrylic", "medium", "coffin", "uv"],
      related: {
         images: {
            img: "/images/menu/desktop/softgel/medium_coffin.webp",
            img2x: "/images/menu/desktop/softgel/medium_coffin@2x.webp",
            img3x: "/images/menu/desktop/softgel/medium_coffin@3x.webp"
         },
         title: "medium coffin",
         link: '/soft-gel/medium-coffin',
      }
   },
   {
      keywords: ["soft gel", "extensions", "fingernails", "cuticles", "nail", "tips", "hands", "substitute", "gel", "acrylic", "long", "medium", "coffin", "uv"],
      related: {
         images: {
            img: "/images/menu/desktop/softgel/long_coffin.webp",
            img2x: "/images/menu/desktop/softgel/long_coffin@2x.webp",
            img3x: "/images/menu/desktop/softgel/long_coffin@3x.webp"
         },
         title: "long coffin",
         link: '/soft-gel/long-coffin',
      }
   },
   {
      keywords: ["soft gel", "extensions", "fingernails", "cuticles", "nail", "tips", "hands", "substitute", "gel", "acrylic", "medium", "square", "uv"],
      related: {
         images: {
            img: "/images/menu/desktop/softgel/medium_square.webp",
            img2x: "/images/menu/desktop/softgel/medium_square@2x.webp",
            img3x: "/images/menu/desktop/softgel/medium_square@3x.webp"
         },
         title: "medium square",
         link: '/soft-gel/medium-square',
      }
   },
   {
      keywords: ["soft gel", "extensions", "fingernails", "cuticles", "nail", "tips", "hands", "substitute", "gel", "acrylic", "short", "medium", "stiletto", "uv"],
      related: {
         images: {
            img: "/images/menu/desktop/softgel/medium_stilletto.webp",
            img2x: "/images/menu/desktop/softgel/medium_stilletto@2x.webp",
            img3x: "/images/menu/desktop/softgel/medium_stilletto@3x.webp"
         },
         title: "stiletto medium",
         link: '/soft-gel/stiletto-medium',
      }
   },
   {
      keywords: ["gel", "nail", "polish", "cream", "mousse", "glue", "acrylic", "fingernails", "monomer", "gloss", "silk", "ethyl", "ethyl methacrylate", "polymerisation inhibitor", "nail salon", "fiberglass", "linen", "uv curing", "buffing", "asthma", "formaldehyde", "toluene", "dibutyl", "dibutyl phthalate", "essentials", "base", "top", "coat", "uv"],
      related: {
         images: {
            img: "/images/menu/desktop/gelish/essentials.webp",
            img2x: "/images/menu/desktop/gelish/essentials@2x.webp",
            img3x: "/images/menu/desktop/gelish/essentials@3x.webp"
         },
         title: "gelish",
         link: '/gelish',
      }
   },
   {
      keywords: ["cat", "eye", "effect", "effects", "glitter", "glamour", "reflect", "magnetic", "velvet", "pure", "Shimmering", "shades", "dark", "magnetize", "uv"],
      related: {
         images: {
            img: "/images/menu/desktop/gelish/cat_eye.webp",
            img2x: "/images/menu/desktop/gelish/cat_eye@2x.webp",
            img3x: "/images/menu/desktop/gelish/cat_eye@3x.webp"
         },
         title: "cat eye",
         link: '/gelish/cat-eye',
      }
   },
   {
      keywords: ["flash", "gel", "glam", "glitter", "shine", "bling", "dripping", "sparkle", "lights", "effect", "effects", "star", "spark", "shine", "uv"],
      related: {
         images: {
            img: "/images/menu/desktop/gelish/flash_gels.webp",
            img2x: "/images/menu/desktop/gelish/flash_gels@2x.webp",
            img3x: "/images/menu/desktop/gelish/flash_gels@3x.webp"
         },
         title: "flash gels",
         link: '/gelish/flash-gels',
      }
   },
   {
      keywords: ["nail", "polish", "morgan", "taylor", "essentials", "base", "top", "coat", "stick", "with", "it", "need", "for", "speed", "react", "daily", "elixir", "make", "it", "last", "mattes", "wrap", "ahead", "grow", "lacquer", "remover", "cleanse", "pure", "accel", "strip", "ease", "erate", "animate", "peel-off", "glitter"],
      related: {
         images: {
            img: "/images/menu/desktop/morgan_taylor/essentials.webp",
            img2x: "/images/menu/desktop/morgan_taylor/essentials@2x.webp",
            img3x: "/images/menu/desktop/morgan_taylor/essentials@3x.webp"
         },
         title: "Morgan taylor",
         link: '/morgan-taylor',
      }
   },
   {
      keywords: ["morgan", "taylor", "naturals", "vegan", "care", "shine", "cuticle", "friendly", "bio-ceramics"],
      related: {
         images: {
            img: "/images/menu/desktop/morgan_taylor/mt_naturals.webp",
            img2x: "/images/menu/desktop/morgan_taylor/mt_naturals@2x.webp",
            img3x: "/images/menu/desktop/morgan_taylor/mt_naturals@3x.webp"
         },
         title: "Morgan Taylor Naturals",
         link: '/morgan-taylor/naturals',
      }
   },
   {
      keywords: ["dip", "powder", "xpress", "brush", "airborne", "spill", "refill", "essentials", "activator", "prep", "base coat", "top coat", "restorer", "french", "intro", "basix", "kit", "ombre", "blooming", "uv"],

      related: {
         images: {
            img: "/images/menu/desktop/extensions/xpress_dip.webp",
            img2x: "/images/menu/desktop/extensions/xpress_dip@2x.webp",
            img3x: "/images/menu/desktop/extensions/xpress_dip@3x.webp"
         },
         title: "Dip Powder",
         link: '/enhancements/xpress-dip-n-brush',
      }
   },
   {
      keywords: ["hard", "gel", "builder", "led", "5 in 1", "five in one", "non yellowing", "uv", "ultra violet", "clear", "acrylic", "white", "pink"],
      related: {
         images: {
            img: "/images/menu/desktop/extensions/hard_gel.webp",
            img2x: "/images/menu/desktop/extensions/hard_gel@2x.webp",
            img3x: "/images/menu/desktop/extensions/hard_gel@3x.webp"
         },
         title: "hard gels",
         link: '/enhancements/hard-gels',
      }
   },
   {
      keywords: ["acrylic", "prohesion", "performance", "gel", "sculpting", "monomer", "probond", "nourish", "ph bond", "elegant pink", "crystal", "clear", "vivid", "white", "stir", "stick", "spoon", "marbling", "brushes", "file", "buffer"],
      related: {
         images: {
            img: "/images/menu/desktop/extensions/prohesion.webp",
            img2x: "/images/menu/desktop/extensions/prohesion@2x.webp",
            img3x: "/images/menu/desktop/extensions/prohesion@3x.webp"
         },
         title: "acrylic",
         link: '/enhancements/prohesion',
      }
   },
   {
      keywords: ["polygel", "acrylic", "all in one", "light", "strong", "monomer free", "no mixing", "no ratios", "no chasing", "squeeze", "slice", "roll", "slip", "natural", "bright", "white", "clear", "soft", "cover", "light", "dark", "pink"],
      related: {
         images: {
            img: "/images/menu/desktop/extensions/polygel.webp",
            img2x: "/images/menu/desktop/extensions/polygel@2x.webp",
            img3x: "/images/menu/desktop/extensions/polygel@3x.webp"
         },
         title: "polygel",
         link: '/enhancements/polygel',
      }
   },
   {
      keywords: ['e-file', "file", "iq", "on the go", "drill", "rpm", "bits", "resistance", "barrel", "customizable", "smart", "torque", "programmable", "digital display", "mag lock charging", "removal", "versatile", "cordless", "lightweight", "diy", "buffing", "care"],
      related: {
         images: {
            img: "/images/menu/desktop/tools/e-file.webp",
            img2x: "/images/menu/desktop/tools/e-file@2x.webp",
            img3x: "/images/menu/desktop/tools/e-file@3x.webp"
         },
         title: "e-files",
         link: '/nail-lamps-tools/e-files',
      }
   },
   {
      keywords: ["dust", "collector", "cleaner", "air", "vortex", "airborne", "particle", "air", "ultra", "slim", "fan", "filter", "comfort", "driven", "go anywhere"],
      related: {
         images: {
            img: "/images/menu/desktop/tools/vortex.webp",
            img2x: "/images/menu/desktop/tools/vortex@2x.webp",
            img3x: "/images/menu/desktop/tools/vortex@3x.webp"
         },
         title: "nail dust collector",
         link: '/nail-lamps-tools/vortex',
      }
   },
   {
      keywords: ["brushes", "tools", "paint", "polishes", "nails", "sculpting"],
      related: {
         images: {
            img: "/images/menu/desktop/tools/nail_tools.webp",
            img2x: "/images/menu/desktop/tools/nail_tools@2x.webp",
            img3x: "/images/menu/desktop/tools/nail_tools@3x.webp"
         },
         title: "brushes and tools",
         link: '/nail-lamps-tools/brushes-and-tools',
      }
   },
   {
      keywords: ["nail care", "strengthener", "cuticle", "vitagel", "recovery", "vitamin a", "vitamin e", "vitamin", "vitamin b5", "damaged nails", "dailyelixir", "keratin", "treatment", "resurfaces", "hydrolyzed", "oil", "nourish", "hyaluronic acid", "hyaluronic", "hydrate", "soften", "reactmax", "satin", "optical brightener"],
      related: {
         images: {
            img: "/images/nail-care/desktop/nail-care/daily_elixir.webp",
            img2x: "/images/nail-care/desktop/nail-care/daily_elixir@2x.webp",
            img3x: "/images/nail-care/desktop/nail-care/daily_elixir@3x.webp"
         },
         title: "nail care",
         link: '/nail-care',
      }
   },
   {
      keywords: ["mani", "pedi", "pedicure", "manicure", "bare luxury", "luxury", "bare", "specialty", "professional", "skin", "care", "feet", "hands", "bareluxury", "cleanses", "detoxifiles", "refines", "rejuvenate", "non staining", "clean rinse", "calm", "detox", "masque", "soak", "purifying", "fragrance", "energy", "lotion", "sugar", "scrub", "massage", "butter", "orange", "lemongrass", "body", "renew", "dissolve", "remover", "callus", "treatment", "purifies", "relieved", "soothed", "refreshed", "motivated", "recovered", "invigorated", "vitalized", "balanced"],
      related: {
         images: {
            img: "/images/menu/desktop/nail-care/bare_luxury.webp",
            img2x: "/images/menu/desktop/nail-care/bare_luxury@2x.webp",
            img3x: "/images/menu/desktop/nail-care/bare_luxury@3x.webp"
         },
         title: "mani and pedi",
         link: '/nail-care/bare-luxury',
      }
   },
   {
      keywords: ["nail art", "art", "creative", "design", "blooming", "gel", "chrome stix", "art forms", "transfer foil gel", "transfer", "foil", "no mess", "led", "effect", "effectsñ", "glazed", "copper", "chameleon", "mirror", "holographic", "one stroke", "pastel", "gold", "silver", "neon", "sticky", "high shine", "beauty", "game changers", "instant"],
      related: {
         images: {
            img: "/images/menu/desktop/nail_arts/foil_gel.webp",
            img2x: "/images/menu/desktop/nail_arts/foil_gel@2x.webp",
            img3x: "/images/menu/desktop/nail_arts/foil_gel@3x.webp"
         },
         title: "nail arts",
         link: '/nail-arts',
      }
   },
   {
      keywords: ["SOLID", "CREAM", "GEL", "POLISH", "soak off", "palette", "neon", "pastel", "natural", "smooth application"],
      related: {
         images: {
            img: "/images/menu/desktop/nail_arts/19774-GEL-CreamGel-Hand-Photo-PrettyPastels-Periwinkle6.webp",
            img2x: "/images/menu/desktop/nail_arts/19774-GEL-CreamGel-Hand-Photo-PrettyPastels-Periwinkle6@2x.webp",
            img3x: "/images/menu/desktop/nail_arts/19774-GEL-CreamGel-Hand-Photo-PrettyPastels-Periwinkle6@3x.webp"
         },
         title: "solid cream gel polish",
         link: '/nail-arts/cream-gel',
      }
   },
]